import { render, staticRenderFns } from "./RefuseDialog.vue?vue&type=template&id=3b853239&scoped=true"
import script from "./RefuseDialog.vue?vue&type=script&lang=js"
export * from "./RefuseDialog.vue?vue&type=script&lang=js"
import style0 from "./RefuseDialog.vue?vue&type=style&index=0&id=3b853239&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b853239",
  null
  
)

export default component.exports